module.exports = __webpack_public_path__ + "img/left2.d8e14ea.png";